export let CallSummaryPersona;
(function (CallSummaryPersona) {
  CallSummaryPersona["SERVICE"] = "Service";
  CallSummaryPersona["SALES"] = "Sales";
})(CallSummaryPersona || (CallSummaryPersona = {}));
export let TransferStatus;
(function (TransferStatus) {
  TransferStatus["READY"] = "READY";
  TransferStatus["RINGING_WARM_TRANSFER"] = "RINGING_WARM_TRANSFER";
  TransferStatus["IN_PROGRESS_WARM_TRANSFER"] = "IN_PROGRESS_WARM_TRANSFER";
  TransferStatus["ACCEPTED"] = "ACCEPTED";
  TransferStatus["REJECTED"] = "REJECTED";
})(TransferStatus || (TransferStatus = {}));
export let TransferDirection;
(function (TransferDirection) {
  TransferDirection["RECEIVING"] = "RECEIVING";
  TransferDirection["SENDING"] = "SENDING";
})(TransferDirection || (TransferDirection = {}));
export let EngagementUpdateStatus;
(function (EngagementUpdateStatus) {
  EngagementUpdateStatus["NONE"] = "NONE";
  EngagementUpdateStatus["PENDING"] = "PENDING";
  EngagementUpdateStatus["SUCCESS"] = "SUCCESS";
  EngagementUpdateStatus["ERROR"] = "ERROR";
})(EngagementUpdateStatus || (EngagementUpdateStatus = {}));
export let AiNoteTakerCallSummaryStatus;
(function (AiNoteTakerCallSummaryStatus) {
  AiNoteTakerCallSummaryStatus["NONE"] = "NONE";
  AiNoteTakerCallSummaryStatus["PENDING"] = "PENDING";
  AiNoteTakerCallSummaryStatus["SUCCESS"] = "SUCCESS";
  AiNoteTakerCallSummaryStatus["ERROR"] = "ERROR";
})(AiNoteTakerCallSummaryStatus || (AiNoteTakerCallSummaryStatus = {}));